const ButtonNavigationLeft = ({ size = 24, fill = null, disabled = false }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="12" fill={disabled ? '#BDBCBC' : '#CE181E'} />
      <g clip-path="url(#clip0_11321_78070)">
        <path
          d="M12.5986 15.3766L12.2022 15.773C12.0344 15.9409 11.763 15.9409 11.5969 15.773L8.12588 12.3038C7.95804 12.1359 7.95804 11.8645 8.12588 11.6985L11.5969 8.22744C11.7648 8.0596 12.0362 8.0596 12.2022 8.22744L12.5986 8.62383C12.7682 8.79345 12.7646 9.0702 12.5915 9.23626L10.4399 11.286H15.5715C15.8089 11.286 16 11.4771 16 11.7146V12.2859C16 12.5234 15.8089 12.7144 15.5715 12.7144H10.4399L12.5915 14.7642C12.7664 14.9303 12.77 15.207 12.5986 15.3766Z"
          fill="#FFFEFE"
        />
      </g>
      <defs>
        <clipPath id="clip0_11321_78070">
          <rect width="8" height="8" fill="white" transform="translate(8 8)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ButtonNavigationLeft;
